module.exports = __webpack_public_path__ + "static/img/buzzer_passivo-1.ef8ff59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/buzzer_passivo-1.svg
// module id = ahpi
// module chunks = 0